import script from "./about_we.vue?vue&type=script&setup=true&lang=js"
export * from "./about_we.vue?vue&type=script&setup=true&lang=js"

import "./about_we.vue?vue&type=style&index=0&id=a0ae1c7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0ae1c7c"]])

export default __exports__